import { PersonalTimeToggle } from './PersonalTimeToggle';
import { IPersonalTime } from '../model/ICheckin';

export const PersonalTimeSelector: React.FC<{ value?: IPersonalTime, onChange: (value?: IPersonalTime) => Promise<void> }> = ({ value, onChange }) => {

    const onClick = async (time: IPersonalTime) => {
        await onChange(time === value ? undefined : time);
    };

    return (
        <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'flex-start', gap: 20, maxWidth: 400, margin: '20px auto 10px'}}>
            <PersonalTimeToggle
                time={IPersonalTime.Low}
                selected={value === IPersonalTime.Low}
                disabled={value !== IPersonalTime.Low && value !== undefined}
                onClick={() => onClick(IPersonalTime.Low)}
            />
            <PersonalTimeToggle
                time={IPersonalTime.Medium}
                selected={value === IPersonalTime.Medium}
                disabled={value !== IPersonalTime.Medium && value !== undefined}
                onClick={() => onClick(IPersonalTime.Medium)}
            />
            <PersonalTimeToggle
                time={IPersonalTime.High}
                selected={value === IPersonalTime.High}
                disabled={value !== IPersonalTime.High && value !== undefined}
                onClick={() => onClick(IPersonalTime.High)}
            />
            <PersonalTimeToggle
                time={IPersonalTime.VeryHigh}
                selected={value === IPersonalTime.VeryHigh}
                disabled={value !== IPersonalTime.VeryHigh && value !== undefined}
                onClick={() => onClick(IPersonalTime.VeryHigh)}
            />
        </div>
    );
};
